import React, { useEffect, useState } from "react"
import { useInView } from "react-intersection-observer"
import { motion, useAnimation } from "framer-motion"

// const SiteInfo = ({ slice }) => (
//   <div className="section site-info">
//     {/* <img className="site-info__image" src={slice.primary.image.url} /> */}
//     <div className="site-info__content container">
//       <p>{slice.primary.text.text}</p>
//     </div>
//   </div>
// )

const SiteInfo = ({ slice }) => {
  const controls = useAnimation()
  const [ref, inView] = useInView({
    threshold: 0.5,
  })

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  return (
    <motion.div
      ref={ref}
      animate={controls}
      transition={{ 
        type: "tween", 
        ease: "easeIn",
         }}
      initial="hidden"
      className="section site-info"
      variants={{
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.8,
          },
        },
        hidden: { 
          opacity: 0,
          y: 50,
         },
      }}
    >
      <div className="site-info__content container">
        <p>{slice.primary.text.text}</p>
      </div>
    </motion.div>
  )
}

export default SiteInfo
